export default __webpack_public_path__ + "static/media/notes-wine.c1f9ed30.svg";